import CustomersEntityLink from './CustomersEntityLink';

export default CustomersEntityLink;
